import CountUp from "./CountUp";
import { useEffect, useState } from "react";

/** Circular animated gauge (0–100). Green ≥ 90, amber ≥ 60, else red. */
export default function HealthGauge({ score = 0, band = "" }) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setPct(Math.max(0, Math.min(100, score))), 60);
    return () => clearTimeout(t);
  }, [score]);

  const size = 224;
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const color = score >= 90 ? "#10b981" : score >= 60 ? "#f59e0b" : "#f43f5e";
  const glow = score >= 90 ? "rgba(16,185,129,0.35)" : score >= 60 ? "rgba(245,158,11,0.35)" : "rgba(244,63,94,0.35)";

  return (
    <div className="relative flex flex-col items-center" data-testid="health-gauge">
      <div className="relative" style={{ width: size, height: size, filter: `drop-shadow(0 0 40px ${glow})` }}>
        <svg width={size} height={size} className="rotate-[-90deg]">
          <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke}/>
          <circle
            cx={size/2} cy={size/2} r={r}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 1.4s cubic-bezier(0.22, 1, 0.36, 1)" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-display font-bold text-white" style={{ fontSize: 62, lineHeight: 1 }}>
            <CountUp value={score}/>
          </div>
          <div className="mt-1 text-[11px] uppercase tracking-[0.2em] font-semibold" style={{ color }}>{band}</div>
        </div>
      </div>
    </div>
  );
}
